import React from 'react';

export const HALF_WIDTH = { upper: 21.5, lower: 20.5 };

export const NAME = { upper: 'Yon kesuvchi', lower: 'Yon kesuvchi' };

/*
 * Upper lateral incisor: narrower than the central, with a markedly rounded
 * disto-incisal angle and a more slender root.
 */
const UPPER_OUTLINE = `M 34 48
    C 31 59.6 29 70.6 28.8 79.6
    C 28.7 86 29.3 91 30.8 93.5
    Q 32 95.8 35.4 96
    L 61.6 95.6
    Q 67 95 69.2 90.4
    C 70.9 86 71.4 77 71 70
    C 70.6 61 68.6 52.4 66 48
    C 65.2 42 64.2 32 61.8 21.4
    C 60.2 14.4 58 8.4 55.4 6.6
    C 53.4 5.2 50.2 5.6 48.2 7.4
    C 45.4 10 43 21 40.4 31.4
    C 38.2 40 36.2 44.4 34 48 Z`;

const UPPER_CERVICAL = 'M 34 48 C 40 42.4 60 42.4 66 48';

const UPPER_DETAILS = [
    'M 42.4 68 C 41.8 76 41.8 85.6 42.6 92.8',
    'M 58.6 66.6 C 59.4 75 59.6 85 58.8 93.4',
];

/*
 * Lower lateral incisor: slightly wider than the lower central and distinctly
 * asymmetric — the incisal edge is tilted distally and the root is bent the
 * same way.
 */
const LOWER_OUTLINE = `M 38 44
    C 35.4 34.4 32.2 25 31 17.4
    C 30.3 12.2 31.2 7.6 33.4 5.8
    Q 34.8 4.6 37.4 4.4
    L 59.4 4.8
    Q 63 5.2 64.8 7.8
    C 66.6 10.2 67.2 14.6 66.4 19.6
    C 65.4 27 63.2 35.4 61 44
    C 62.8 53.4 63.2 64.6 61.8 74.6
    C 60.8 82.8 58.8 89.6 56 92.4
    Q 52.4 95.8 48.4 94
    C 45.6 92.8 43.4 88.2 42 82.2
    C 40.2 74.6 39 63.2 38.4 53.8
    C 38.2 49.6 38 46.4 38 44 Z`;

const LOWER_CERVICAL = 'M 38 44 C 43.4 48.2 55.6 48.2 61 44';

const LOWER_DETAILS = [
    'M 43 10 C 42.6 18 43 26 43.8 33',
    'M 56 11 C 56.6 19 56.2 27 55.4 34',
    'M 50 52 C 50.4 62 50.6 74 50.2 86',
];

export default function LateralIncisor({ jaw }) {
    const isUpper = jaw === 'upper';

    return (
        <>
            <path d={isUpper ? UPPER_OUTLINE : LOWER_OUTLINE} className="dental-tooth__body" />
            <path d={isUpper ? UPPER_CERVICAL : LOWER_CERVICAL} className="dental-tooth__line" />
            {(isUpper ? UPPER_DETAILS : LOWER_DETAILS).map((d) => (
                <path key={d} d={d} className="dental-tooth__detail" />
            ))}
        </>
    );
}
